import {SupplementModelV1} from 'resources/GeneratedModels/Supplement/SupplementModel.v1';

import {baseSupplementExtensions} from '../supplementHelpers/baseSupplement.extensions';
import {baseSupplementValidators} from '../supplementHelpers/baseSupplement.validators';

SupplementModelV1.extend(baseSupplementExtensions);
SupplementModelV1.addValidators(baseSupplementValidators);

export {SupplementModelV1};
